
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

Swiper.use([Navigation, Pagination, Autoplay])

export const RestaurantHeroSlider = () => {
  const $sliderWrapper = $('.js-restaurantHeroSlider');
  if ( !$sliderWrapper.length ) {
      return
  }

  $(document).ready(function() {
    const slider = new Swiper('.js-restaurantHeroSlider', {
      autoplay: {
        delay: 3600,
      },
      speed: 600,
      pagination: {
        el: '.c-restaurantHeroSlider__pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return (
            `<span class="c-restaurantHeroSlider__paginationItem ${className}">
              <span></span>
              <span>${index + 1}</span>
            </span>`
          )
        },
      },
  
      // Navigation arrows
      navigation: {
        nextEl: '.c-restaurantHeroSlider__nextSlide',
        prevEl: '.c-restaurantHeroSlider__prevSlide',
      },
    })
    console.log(slider)
  });
}